<script setup lang="ts">
import MmIcon from './MmIcon.vue'
import './choice.css'
withDefaults(defineProps<{ modelValue?: boolean; label: string; disabled?: boolean; name?: string }>(), { modelValue: false, disabled: false })
const emit = defineEmits<{ 'update:modelValue': [value: boolean]; change: [value: boolean] }>()
const change = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
  emit('change', checked)
}
</script>

<template>
  <label class="mm-checkbox">
    <span class="mm-checkbox-control"><input class="mm-choice-input" type="checkbox" :name="name" :checked="modelValue" :aria-checked="modelValue" :disabled="disabled" @change="change"><MmIcon v-if="modelValue" name="check" :size="16" /></span>
    <span>{{ label }}</span>
  </label>
</template>

<style scoped>
.mm-checkbox { display: flex; align-items: center; gap: var(--s-3); min-height: 44px; cursor: pointer; color: var(--text-2); }
.mm-checkbox-control { display: grid; place-items: center; flex: none; width: 20px; height: 20px; }
.mm-checkbox-control > * { grid-area: 1 / 1; }
.mm-checkbox-control :deep(.ic) { pointer-events: none; color: var(--accent-ink); }
</style>
